import { render, staticRenderFns } from "./CreateFolderForm.vue?vue&type=template&id=61d7d024&"
import script from "./CreateFolderForm.vue?vue&type=script&lang=js&"
export * from "./CreateFolderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports